import React from 'react';

import { uploadUrl } from './uploadUrl';
import {
  IconAnchor,
  IconContainer,
  IconLabel,
  NotificationDot,
} from './buttonStyles';
import trackClick from 'js/utils/trackClick';
import { Icon } from 'js/design_system/Icon';

type Props = {
  hasUnseenClaimablePapers: boolean;
  hasUnseenUploadableStubs: boolean;
};

const UploadButton = ({
  hasUnseenClaimablePapers,
  hasUnseenUploadableStubs,
}: Props) => {
  const url = uploadUrl({
    hasUnseenUploadableStubs,
    hasUnseenClaimablePapers,
    trigger: 'nav',
  });

  const handleOnClick = () => {
    trackClick({
      source: 'nav-bar--upload-button',
    });
  };

  return (
    <IconAnchor href={url} onClick={handleOnClick}>
      <IconContainer>
        <Icon name="arrow_upward" size={24} />
      </IconContainer>
      <IconLabel>
        Upload
        {(hasUnseenClaimablePapers || hasUnseenUploadableStubs) && (
          <NotificationDot />
        )}
      </IconLabel>
    </IconAnchor>
  );
};

export default UploadButton;
